import WorkCycleForm from './WorkCycleForm';
export default WorkCycleForm;